import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Elementul from 'element-ui'
import axios from'axios'
import 'element-ui/lib/theme-chalk/index.css'
import '@/axiosInterceptos.js';
import vueEsign from 'vue-esign'

Vue.use(vueEsign)
Vue.config.productionTip = false
Vue.use(Elementul)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// axios.interceptors.request.use(config => {//声明请求拦截器
//     console.log(config);
//     config.headers.Authorization = window.sessionStorage.getItem('token')//获取token值
//     return config//一定要返回
// })
Vue.prototype.$http = axios
